import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgSelectModule } from '@ng-select/ng-select';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgChartsModule } from 'ng2-charts';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TimeagoModule } from "ngx-timeago";
import { ScrollingModule } from '@angular/cdk/scrolling';
// import { MySocketWrapper } from './services/socket-service/socket-wrapper';
// import { SocketService } from './services/socket-service/socket-service.service';
import { DatePipe } from './pipes/date-pipe/date.pipe';
import { SideNavComponent } from './components/shared/layout/side-nav/side-nav.component';
import { HeaderComponent } from './components/shared/layout/header/header.component';
import { OWL_DATE_TIME_FORMATS, OwlDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { ToastrModule } from 'ngx-toastr';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SigninComponent } from './components/auth/signin/signin.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { TokenInterceptor } from './services/app/token-interceptor/token.interceptor';
import { SortByPipe } from './pipes/order-by/order-by.pipe';
import { CamelCasePipe } from './pipes/camelcase.filter/camelcase.filter.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxUiLoaderConfig, NgxUiLoaderHttpModule, NgxUiLoaderModule } from 'ngx-ui-loader';
import { LevelofserviceListComponent } from './components/configurations/levelofservice/levelofservice-list/levelofservice-list.component';
import { AddLevelofserviceComponent } from './components/configurations/levelofservice/add-levelofservice/add-levelofservice.component';
import { SpaceTypesListComponent } from './components/configurations/spacetype/space-types-list/space-types-list.component';
import { AddSpaceTypesComponent } from './components/configurations/spacetype/add-space-types/add-space-types.component';
import { ClockTimePipe } from './pipes/clock-time/clock-time.pipe';
import { FilterPipe } from './pipes/list-filter-pipe/list-filter-pipe';
import { CircleTimerModule } from "./libraries/circle-timer/src/lib/circle-timer.module";
import { MySocketWrapper } from './services/app/socket-service/socket-wrapper';
import { SocketService } from './services/app/socket-service/socket-service.service';
import { SignupListComponent } from './components/signups/signup-list/signup-list.component';
import { AddSignupComponent } from './components/signups/add-signup/add-signup.component';
import { CredentialListComponent } from './components/credentials/credentials-company/credential-list/credential-list.component';
import { CommonModule } from '@angular/common';
import { CompanyListComponent } from './components/companies/company-list/company-list.component';
import { AddCompanyComponent } from './components/companies/add-company/add-company.component';
import { CompanyComponent } from './components/credentials/company/company.component';
import { DriverComponent } from './components/credentials/drivers/driver/driver.component';
import { WrapperComponent } from './components/credentials/wrapper/wrapper.component';
import { DocumentsListComponent } from './components/configurations/documents/documents-list/documents-list.component';
import { AddDocumentComponent } from './components/configurations/documents/add-document/add-document.component';
import { FareListComponent } from './components/credentials/fare/fare-list/fare-list.component';
import { AddFareComponent } from './components/credentials/fare/add-fare/add-fare.component';
import { ThresholdComponent } from './components/credentials/threshold/threshold.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { GooglePlaceDirective } from './directives/google-places-directive/google-place.directive';
import { SignupDetailsSlideoutComponent } from './components/slideouts/signup-details/signup-details-slideout.component';
import { VehiclesComponent } from './components/credentials/vehicle/vehicles/vehicles.component';
import { DriverVerificationSlideoutComponent } from './components/slideouts/driver-verification/driver-verification-slideout.component';
import { AddDriverComponent } from './components/credentials/drivers/add-driver/add-driver.component';
import { AddVehicleComponent } from './components/credentials/vehicle/add-vehicle/add-vehicle.component';
import { AddCredentialCompanyComponent } from './components/credentials/credentials-company/add-credential-company/add-credential-company.component';
import { VehicleVerificationComponent } from './components/slideouts/vehicle-verification/vehicle-verification.component';
import { ThresholdListComponent } from './components/credentials/threshold-list/threshold-list.component';
import { UsersListComponent } from './components/user/users-list/users-list.component';
import { AddUserComponent } from './components/user/add-user/add-user.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AddRoleComponent } from './components/role/add-role/add-role.component';
import { ListRoleComponent } from './components/role/list-role/list-role.component';
import { NotificationModalComponent } from './components/slideouts/notification-modal/notification-modal.component';
import { QuickbookNotificationModalComponent } from './components/slideouts/quickbook-notification-modal/quickbook-notification-modal.component';
import { QuickbookNotificationsComponent } from './components/quickbook/notifications/quickbook-notifications/quickbook-notifications.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { ReportComponent } from './components/distributions/kpis/report/report.component';
import { AddMemberComponent } from './components/distributions/members/add-member/add-member.component';
import { CreateTripComponent } from './components/distributions/trip-intake/create-trip/create-trip.component';
import { TripListComponent } from './components/distributions/trips/trip-list/trip-list.component';
import { MemberListComponent } from './components/distributions/members/member-list/member-list.component';
import { FileParsingComponent } from './components/distributions/trip-intake/file-parsing/file-parsing/file-parsing.component';
import { TripDetailModalComponent } from './components/slideouts/distributions/trip-detail-modal/trip-detail-modal.component';
import { StandingOrderListComponent } from './components/distributions/trip-intake/standing-order/standing-order-list/standing-order-list.component';
import { AddAddonComponent } from './components/configurations/addon/add-addon/add-addon.component';
import { ListAddonComponent } from './components/configurations/addon/list-addon/list-addon.component';
import { AppointmenttypeComponent } from './components/configurations/appointment/add-appointment/appointmenttype.component';
import { AppointmentlistComponent } from './components/configurations/appointment/appointment-list/appointmentlist.component';
import { StandingorderDetailModalComponent } from './components/slideouts/standingorder-detail-modal/standingorder-detail-modal.component';
import { TripsDistributionModalComponent } from './components/slideouts/distributions/trips-distribution-modal/trips-distribution-modal.component';
import { TripMonitoringComponent } from './components/distributions/trips/trip-monitoring/trip-monitoring.component';
import { ServiceAreasListingComponent } from './components/configurations/service-areas/service-areas-listing/service-areas-listing.component';
import { ServiceAreasAddComponent } from './components/configurations/service-areas/service-areas-add/service-areas-add.component';
import { MemberWrapperComponent } from './components/distributions/members/member-wrapper/member-wrapper.component';
import { FundingSourceListComponent } from './components/configurations/funding-source/funding-source-list/funding-source-list.component';
import { AddFundingSourceComponent } from './components/configurations/funding-source/add-funding-source/add-funding-source.component';
import { CancelModalComponent } from './components/slideouts/cancel-modal/cancel-modal.component';
import { AddCancelReasonComponent } from './components/configurations/cancelReason/add-cancel-reason/add-cancel-reason.component';
import { ListCancelReasonComponent } from './components/configurations/cancelReason/list-cancel-reason/list-cancel-reason.component';
import { NotesModalComponent } from './components/slideouts/notes/notes-modal/notes-modal.component';
import { TripCardComponent } from './components/shared/layout/trips/trip-card/trip-card.component';
import { MultiCancelModalComponent } from './components/slideouts/multi-cancel-modal/multi-cancel-modal.component';
import { TripActionDropdownComponent } from './components/shared/dropdowns/trip-action-dropdown/trip-action-dropdown.component';
import { OutsideClickDirective } from './directives/outside-click-directive/outside-click.directive';
import { AddPlacetypesComponent } from './components/configurations/placetypes/add-placetypes/add-placetypes.component';
import { ListPlacetypesComponent } from './components/configurations/placetypes/list-placetypes/list-placetypes.component';
import { TrimInputDirective } from './directives/trim-input-directive/trim-input.directive';
import { DatePickerReadonlyDirective } from './directives/date-picker-readonly-directive/date-picker-readonly.directive';
import { MemberTripsModalComponent } from './components/slideouts/member-trips-modal/member-trips-modal.component';
import { TripListingComponent } from './components/shared/layout/trips/trip-listing/trip-listing.component';
import { MemberDetailModalComponent } from './components/slideouts/member-detail-modal/member-detail-modal.component';
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, OwlMomentDateTimeModule } from '@danielmoncada/angular-datetime-picker-moment-adapter';
import { PhoneNumberFormatterDirective } from './directives/phone-number-format-directive/phone-number-formatter.directive';
import { GoogleMapsInitializer } from './services/app/googlemap-key-service/google-maps-initializer.service';
import { ConvertPhoneNumberDirective } from './directives/number-directive/convert-phone-number.directive';
import { AddPartnerpayComponent } from './components/partner-pay/add-partnerpay/add-partnerpay.component';
import { PartnerpayListComponent } from './components/partner-pay/partnerpay-list/partnerpay-list.component';
import { DashboardListingComponent } from './components/dashboard/dashboard-listing/dashboard-listing.component';
import { VoiceNavigationComponent } from './components/shared/voice-navigation/voice-navigation.component';
import { StandingOrderTripWrapperComponent } from './components/distributions/trip-intake/standing-order/standing-order-trip-wrapper/standing-order-trip-wrapper.component';
import { CalculateFareModalComponent } from './components/slideouts/calculate-fare-modal/calculate-fare-modal.component';
import { AutoDistributionModalComponent } from './components/slideouts/auto-distribution-modal/auto-distribution-modal.component';
import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { ChatThreadComponent } from './components/support/chat-thread/chat-thread.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';
import { SupportContactPickerComponent } from './components/support/support-contact-picker/support-contact-picker.component';
import { SupportReferenceDetailComponent } from './components/support/support-reference-detail/support-reference-detail.component';
import { GraphComponent } from './components/shared/layout/graph/graph.component';
import { StatisticsGraphViewComponent } from './components/distributions/kpis/statistics-graph-view/statistics-graph-view.component';
import { MapViewComponent } from './components/map/map-view/map-view.component';
import { ListEventComponent } from './components/configurations/event/list-event/list-event.component';
import { ListGpsComponent } from './components/configurations/gps/list-gps/list-gps.component';
import { MapDashboardComponent } from './components/dashboard/map-dashboard/map-dashboard.component';
import { AddressPickerModalComponent } from './components/slideouts/address-picker-modal/address-picker-modal.component';
import { AddConfigurationComponent } from './components/credentials/configuration/add-configuration/add-configuration.component';
import { CompanyConfigurationComponent } from './components/credentials/configurationForm/company-configuration/company-configuration.component';
import { TripTrailsComponent } from './components/slideouts/trip-trails-modal/trip-trails/trip-trails.component';
import { DobFormatterPipe } from './pipes/dob-formatter/dob-formatter.pipe';
import { ReportConfigurationModalComponent } from './components/slideouts/report-configuration-modal/report-configuration-modal.component';
import { CustomersListComponent } from './components/quickbook/customers/customers-list/customers-list.component';
import { AddCustomerComponent } from './components/quickbook/customers/add-customer/add-customer.component';
import { AddInvoiceComponent } from './components/quickbook/invoices/add-invoice/add-invoice.component';
import { InvoicesListComponent } from './components/quickbook/invoices/invoices-list/invoices-list.component';
import { AddProductServiceComponent } from './components/quickbook/product-services/add-product-service/add-product-service.component';
import { ProductListComponent } from './components/quickbook/product-services/product-list/product-list.component';
import { VendorsListComponent } from './components/quickbook/vendors/vendors-list/vendors-list.component';
import { AddVendorComponent } from './components/quickbook/vendors/add-vendor/add-vendor.component';
import { BillsListComponent } from './components/quickbook/bills/bills-list/bills-list.component';
import { AddBillComponent } from './components/quickbook/bills/add-bill/add-bill.component';
import { PayBillComponent } from './components/quickbook/bills/pay-bill/pay-bill.component';
import { ReceivePaymentComponent } from './components/quickbook/invoices/receive-payment/receive-payment.component';
import { BillPaymentsListComponent } from './components/quickbook/bill-payments/bill-payments-list/bill-payments-list.component';
import { InvoicePaymentsListComponent } from './components/quickbook/invoice-payments/invoice-payments-list/invoice-payments-list.component';
import { VendorEditModalComponent } from './components/quickbook/modals/vendor-edit-modal/vendor-edit-modal.component';
import { VendorDetailModalComponent } from './components/slideouts/vendor-detail-modal/vendor-detail-modal.component';
import { BatchPaymentModalComponent } from './components/quickbook/invoices/batch-payment-modal/batch-payment-modal.component';
import { ReferencePickerModalComponent } from './components/slideouts/reference-picker-modal/reference-picker-modal.component';
import { RaiseTicketModalComponent } from './components/slideouts/raise-ticket-modal/raise-ticket-modal.component';
import { BillDetailModalComponent } from './components/slideouts/bill-detail-modal/bill-detail-modal.component';
import { GlobalConfigurationComponent } from './components/credentials/configuration/global-configuration/global-configuration.component';
import { QbActionDropdownComponent } from './components/shared/dropdowns/qb-action-dropdown/qb-action-dropdown.component';
import { InvoiceDetailModalComponent } from './components/slideouts/invoice-detail-modal/invoice-detail-modal.component';
import { CustomerDetailModalComponent } from './components/slideouts/customer-detail-modal/customer-detail-modal.component';
import { ServiceDetailModalComponent } from './components/slideouts/service-detail-modal/service-detail-modal.component';
import { SectionsPermissionsGridComponent } from './components/role/sections-permissions-grid/sections-permissions-grid.component';
import { TripLogsModalComponent } from './components/slideouts/trip-logs-modal/trip-logs-modal.component';
import { BillingTripRejectReasonModalComponent } from './components/slideouts/billing-trip-reject-reason-modal/billing-trip-reject-reason-modal.component';
import { TripSignatureModalComponent } from './components/slideouts/trip-signature-modal/trip-signature-modal.component';
import { FundingSourceEditModalComponent } from './components/slideouts/funding-source-edit-modal/funding-source-edit-modal.component';
import { CustomerEditModalComponent } from './components/quickbook/modals/customer-edit-modal/customer-edit-modal.component';
import { LevelofserviceEditModalComponent } from './components/slideouts/levelofservice-edit-modal/levelofservice-edit-modal.component';
import { SpacetypeEditModalComponent } from './components/slideouts/spacetype-edit-modal/spacetype-edit-modal.component';
import { AppointmentTypeEditModalComponent } from './components/slideouts/appointment-type-edit-modal/appointment-type-edit-modal.component';
import { AddonsEditModalComponent } from './components/slideouts/addons-edit-modal/addons-edit-modal.component';
import { ServiceareasEditModalComponent } from './components/slideouts/serviceareas-edit-modal/serviceareas-edit-modal.component';
import { ChangereasonsEditModalComponent } from './components/slideouts/changereasons-edit-modal/changereasons-edit-modal.component';
import { PlacetypeEditModalComponent } from './components/slideouts/placetype-edit-modal/placetype-edit-modal.component';
import { CompanyEditModalComponent } from './components/slideouts/company-edit-modal/company-edit-modal.component';
import { CompanyDriverEditModalComponent } from './components/slideouts/company-driver-edit-modal/company-driver-edit-modal.component';
import { CompanyVehicleEditModalComponent } from './components/slideouts/company-vehicle-edit-modal/company-vehicle-edit-modal.component';
import { CompanyThresholdEditModalComponent } from './components/slideouts/company-threshold-edit-modal/company-threshold-edit-modal.component';
import { InvoiceTripsComponent } from './components/quickbook/invoices/invoice-trips/invoice-trips.component';
import { WillcallmodalComponent } from './components/slideouts/willcallmodal/willcallmodal.component';
import { UsersEditModalComponent } from './components/slideouts/users-edit-modal/users-edit-modal.component';
import { RolesEditModalComponent } from './components/slideouts/roles-edit-modal/roles-edit-modal.component';
import { PendingCancelModalComponent } from './components/slideouts/pending-cancel-modal/pending-cancel-modal.component';
import { BillingListComponent } from './components/billing-vendor/billing-list/billing-list.component';
import { AdjustmentFormComponent } from './components/billing-vendor/adjustment-form/adjustment-form.component';
import { FsBillingListComponent } from './components/billing-fundingsource/fs-billing-list/fs-billing-list.component';
import { FsAdjustmentFormComponent } from './components/billing-fundingsource/fs-adjustment-form/fs-adjustment-form.component';
import { MemberMergeModalComponent } from './components/slideouts/member-merge-modal/member-merge-modal.component';
import { AttachmentListComponent } from './components/credentials/attachment/attachment-list/attachment-list.component';
import { UploadAttachmentComponent } from './components/credentials/attachment/upload-attachment/upload-attachment.component';
import { AttachmentEditModalComponent } from './components/slideouts/attachment-edit-modal/attachment-edit-modal.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { StagingTripComponent } from './components/distributions/trips/staging-trip/staging-trip.component';
import { PaymentsListComponent } from './components/payments/payments-list/payments-list.component';
import { TransactionsListComponent } from './components/payments/transactions-list/transactions-list.component';
import { ManualsListComponent } from './components/payments/manuals-list/manuals-list.component';
import { ToolTipDirective } from './directives/tooltip-directive/tool-tip.directive';
import { OnboardingActionDropdownComponent } from './components/shared/dropdowns/onboarding-action-dropdown/onboarding-action-dropdown.component';
import { OnboardingLogsModalComponent } from './components/slideouts/onboarding-logs-modal/onboarding-logs-modal.component';
import { TransactionRefundModalComponent } from './components/slideouts/transaction-refund-modal/transaction-refund-modal.component';
import { ExpiredDocumentsModalComponent } from './components/slideouts/expired-documents-modal/expired-documents-modal.component';
import { RejectReasonModalComponent } from './components/slideouts/reject-reason-modal/reject-reason-modal.component';
import { TransactionActionDropdownComponent } from './components/shared/dropdowns/transaction-action-dropdown/transaction-action-dropdown.component';
import { CopyToClipboardDirective } from './directives/clipboard-directive/copy-to-clipboard.directive';
import { PrimaryDiagnosisListComponent } from './components/billing/primary-diagnosis/primary-diagnosis-list/primary-diagnosis-list.component';
import { AddPrimaryDiagnosisComponent } from './components/billing/primary-diagnosis/add-primary-diagnosis/add-primary-diagnosis.component';
import { AddModifierCodeComponent } from './components/billing/modifier-codes/add-modifier-code/add-modifier-code.component';
import { ModifierCodesListComponent } from './components/billing/modifier-codes/modifier-codes-list/modifier-codes-list.component';
import { PrimaryDiagnosisEditModalComponent } from './components/slideouts/primary-diagnosis-edit-modal/primary-diagnosis-edit-modal.component';
import { ModifierCodeEditModalComponent } from './components/slideouts/modifier-code-edit-modal/modifier-code-edit-modal.component';
import { RelationLegModalComponent } from './components/slideouts/relation-leg-modal/relation-leg-modal/relation-leg-modal.component';
import { DocumentsStatisticsComponent } from './components/documents-statistics/documents-statistics.component';
import { TutorialListComponent } from './components/tutorials/tutorial-list/tutorial-list.component';
import { AddTutorialComponent } from './components/tutorials/add-tutorial/add-tutorial.component';
import { TutorialEditModalComponent } from './components/slideouts/tutorials/tutorial-edit-modal/tutorial-edit-modal.component';
import { ManualPaymentModalComponent } from './components/slideouts/manual-payment-modal/manual-payment-modal.component';


export const MY_MOMENT_FORMATS = {
  fullPickerInput: 'MM/DD/YYYY HHmm',
  parseInput: 'l LT',
  datePickerInput: 'l',
  timePickerInput: 'HH:mm',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'red',
  bgsOpacity: 0.5,
  bgsPosition: 'bottom-right',
  bgsSize: 80,
  bgsType: 'ball-spin-clockwise',
  blur: 0,
  fgsColor: '#727cf5',
  fgsPosition: 'center-center',
  fgsSize: 0,
  fgsType: 'ball-spin',
  gap: 24,
  logoPosition: 'center-center',
  logoSize: 150,
  logoUrl: '',
  masterLoaderId: 'master',
  overlayBorderRadius: '0',
  overlayColor: '#ffffff00',
  pbColor: '#727cf5',
  pbDirection: 'ltr',
  pbThickness: 3,
  hasProgressBar: true,
  text: '',
  textColor: '#FFFFFF',
  textPosition: 'center-center',
};

@NgModule({
  declarations: [
    ManualPaymentModalComponent,
    AppComponent,
    SideNavComponent,
    HeaderComponent,
    SigninComponent,
    ResetPasswordComponent,
    SortByPipe,
    CamelCasePipe,
    ClockTimePipe,
    FilterPipe,
    DatePipe,
    LevelofserviceListComponent,
    AddLevelofserviceComponent,
    SpaceTypesListComponent,
    AddSpaceTypesComponent,
    SignupListComponent,
    AddSignupComponent,
    CredentialListComponent,
    CompanyListComponent,
    AddCompanyComponent,
    CompanyComponent,
    DriverComponent,
    WrapperComponent,
    DocumentsListComponent,
    AddDocumentComponent,
    FareListComponent,
    AddFareComponent,
    ThresholdComponent,
    AddLevelofserviceComponent,
    LevelofserviceListComponent,
    GooglePlaceDirective,
    SignupDetailsSlideoutComponent,
    VehiclesComponent,
    DriverVerificationSlideoutComponent,
    AddDriverComponent,
    AddVehicleComponent,
    AddCredentialCompanyComponent,
    VehicleVerificationComponent,
    ThresholdListComponent,
    UsersListComponent,
    AddUserComponent,
    ProfileComponent,
    AddRoleComponent,
    ListRoleComponent,
    NotificationModalComponent,
    QuickbookNotificationModalComponent,
    NotificationsComponent,
    QuickbookNotificationsComponent,
    ReportComponent,
    AddMemberComponent,
    CreateTripComponent,
    TripListComponent,
    MemberListComponent,
    FileParsingComponent,
    TripDetailModalComponent,
    AppointmentlistComponent,
    AppointmenttypeComponent,
    StandingOrderListComponent,
    AddAddonComponent,
    ListAddonComponent,
    TripsDistributionModalComponent,
    TripMonitoringComponent,
    StandingorderDetailModalComponent,
    TripsDistributionModalComponent,
    ServiceAreasListingComponent,
    ServiceAreasAddComponent,
    MemberWrapperComponent,
    FundingSourceListComponent,
    AddFundingSourceComponent,
    StandingOrderTripWrapperComponent,
    CancelModalComponent,
    MultiCancelModalComponent,
    CancelModalComponent,
    AddCancelReasonComponent,
    ListCancelReasonComponent,
    TripCardComponent,
    NotesModalComponent,
    TripActionDropdownComponent,
    OutsideClickDirective,
    AddPlacetypesComponent,
    ListPlacetypesComponent,
    TrimInputDirective,
    DatePickerReadonlyDirective,
    MemberTripsModalComponent,
    TripListingComponent,
    MemberDetailModalComponent,
    PhoneNumberFormatterDirective,
    ConvertPhoneNumberDirective,
    AddPartnerpayComponent,
    PartnerpayListComponent,
    DashboardListingComponent,
    VoiceNavigationComponent,
    CalculateFareModalComponent,
    AutoDistributionModalComponent,
    SupportTicketsComponent,
    SupportChatComponent,
    ChatThreadComponent,
    TicketDetailComponent,
    AddSupportTicketComponent,
    SupportContactPickerComponent,
    SupportReferenceDetailComponent,
    AdjustmentFormComponent,
    GraphComponent,
    StatisticsGraphViewComponent,
    MapViewComponent,
    ListEventComponent,
    ListGpsComponent,
    MapDashboardComponent,
    BillingListComponent,
    AddressPickerModalComponent,
    AddConfigurationComponent,
    CompanyConfigurationComponent,
    TripTrailsComponent,
    DobFormatterPipe,
    ReportConfigurationModalComponent,
    CustomersListComponent,
    AddCustomerComponent,
    AddInvoiceComponent,
    InvoicesListComponent,
    AddProductServiceComponent,
    ProductListComponent,
    VendorsListComponent,
    AddVendorComponent,
    BillsListComponent,
    AddBillComponent,
    PayBillComponent,
    ReceivePaymentComponent,
    BillPaymentsListComponent,
    InvoicePaymentsListComponent,
    VendorEditModalComponent,
    VendorDetailModalComponent,
    BillDetailModalComponent,
    ReferencePickerModalComponent,
    RaiseTicketModalComponent,
    BatchPaymentModalComponent,
    GlobalConfigurationComponent,
    QbActionDropdownComponent,
    InvoiceDetailModalComponent,
    CustomerDetailModalComponent,
    ServiceDetailModalComponent,
    SectionsPermissionsGridComponent,
    TripLogsModalComponent,
    BillingTripRejectReasonModalComponent,
    TripSignatureModalComponent,
    FundingSourceEditModalComponent,
    CustomerEditModalComponent,
    UsersEditModalComponent,
    RolesEditModalComponent,
    WillcallmodalComponent,
    InvoiceTripsComponent,
    LevelofserviceEditModalComponent,
    SpacetypeEditModalComponent,
    AppointmentTypeEditModalComponent,
    AddonsEditModalComponent,
    ServiceareasEditModalComponent,
    ChangereasonsEditModalComponent,
    PlacetypeEditModalComponent,
    CompanyEditModalComponent,
    CompanyDriverEditModalComponent,
    CompanyVehicleEditModalComponent,
    CompanyThresholdEditModalComponent,
    PendingCancelModalComponent,
    FsBillingListComponent,
    FsAdjustmentFormComponent,
    MemberMergeModalComponent,
    AttachmentListComponent,
    UploadAttachmentComponent,
    AttachmentEditModalComponent,
    ForgotPasswordComponent,
    StagingTripComponent,
    PaymentsListComponent,
    TransactionsListComponent,
    ManualsListComponent,
    ToolTipDirective,
    OnboardingActionDropdownComponent,
    OnboardingLogsModalComponent,
    TransactionRefundModalComponent,
    ExpiredDocumentsModalComponent,
    RejectReasonModalComponent,
    TransactionActionDropdownComponent,
    CopyToClipboardDirective,
    PrimaryDiagnosisListComponent,
    AddPrimaryDiagnosisComponent,
    AddModifierCodeComponent,
    ModifierCodesListComponent,
    PrimaryDiagnosisEditModalComponent,
    ModifierCodeEditModalComponent,
    RelationLegModalComponent,
    TutorialListComponent,
    AddTutorialComponent,
    TutorialEditModalComponent,
    DocumentsStatisticsComponent
  ],
  imports: [
    BrowserModule,
    NgChartsModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxPaginationModule,
    TimeagoModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig), // import NgxUiLoaderModule
    NgxUiLoaderHttpModule.forRoot({
      exclude: [
      ],
      excludeRegexp: [
        'notifications/unread-count',
        // support chat requests run in the background while the user is chatting
        'support/chats/'
      ],
      showForeground: true
    }),
    OwlDateTimeModule,
    OwlMomentDateTimeModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      maxOpened: 6,
      autoDismiss: true,
      positionClass: 'toast-bottom-left',
      // preventDuplicates: true,
      progressBar: true
    }),
    NgMultiSelectDropDownModule.forRoot(),
    GoogleMapsModule,
    NgSelectModule,
    CircleTimerModule,
    CommonModule,
    ScrollingModule


  ],
  // providers: [
  //   { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
  // ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (initializer: GoogleMapsInitializer) => () => initializer.initialize(),
      deps: [GoogleMapsInitializer],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    // { provide: AuthorizationGuard, useClass: AuthorizationGuard },
    // { provide: UnAuthorizationGuard, useClass: UnAuthorizationGuard },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } },

    // {
    //   provide: PERFECT_SCROLLBAR_CONFIG,
    //   useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    // },
    DatePipe,
    MySocketWrapper,
    SocketService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



